import React from 'react';
import Wrapper from '../../components/Wrapper/index.js';
import Menu from '../../components/Menu/index.js';
import styles from './styles.scss.js';

const HelpPage = ({ list, title, children }) => (React.createElement(Wrapper, { className: styles.wrapper },
    React.createElement("div", null,
        React.createElement(Menu, { className: styles.menu, list: list })),
    React.createElement("div", { className: styles.content },
        React.createElement("h1", { className: styles.title }, title),
        children)));

export { HelpPage as default };
//# sourceMappingURL=index.js.map
